import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const SMALL_SCREEN = typeof window !== "undefined" && window.innerWidth < 760;

export function sized(url, w) {
  if (!url || !url.includes("images.unsplash.com")) return url;
  const width = SMALL_SCREEN ? Math.min(w, 720) : w;
  return url.replace(/([?&])w=\d+/, `$1w=${width}`).replace(/([?&])q=\d+/, `$1q=${SMALL_SCREEN ? 65 : 80}`);
}
